import { NewsWidget, WidgetHost } from '@/core/widgets/export';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTowerCell } from '@fortawesome/free-solid-svg-icons';
import { MarketSignalContextProvider } from '@/modules/market-signals/contexts/market-signal-context';
import MarketSignalSingleScroller from '@/modules/market-signals/components/market-signals/scroller/market-signal-single-scroller';

export class MarketSignalSingleScrollerWidget implements NewsWidget {
  constructor(
    private streamId: string,
    private title: string,
    private requiredPermissions: string[],
  ) {}
  get defaultRoute(): string {
    return '';
  }

  get defaultTitle(): string {
    return this.title;
  }

  async hasPermission(permissions: string[]): Promise<boolean> {
    return !this.shouldHideToUser(permissions);
  }

  shouldHideToUser(permissions: string[]): boolean {
    for (const p of this.requiredPermissions) {
      if (permissions.includes(p)) return false;
    }

    return true;
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get headerPanel(): JSX.Element {
    return (
      <span>
        <FontAwesomeIcon icon={faTowerCell} /> {this.title}
      </span>
    );
  }

  get id(): string {
    return 'market-signals-' + this.streamId;
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: (
          <MarketSignalContextProvider>
            <MarketSignalSingleScroller selectedStream={this.streamId} />
          </MarketSignalContextProvider>
        ),
      },
    ];
  }

  get shortTitle(): JSX.Element {
    return this.headerPanel;
  }
}
